module.exports = __webpack_public_path__ + "static/media/icon-domicilio.46f264a6.svg";